enum CardPaddingSize {
  SM = "sm",
  MD = "md",
}

const CARD_EVENT_CLICK = "click-card";

export { CardPaddingSize, CARD_EVENT_CLICK };
